export default __webpack_public_path__ + "static/Lebanese-Petra-min-1e0404b8f8519d3b0d9f4b21c1c616c6.pdf";